export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/comitecontraloria.jpg",
        "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid0jmLNs4UXt5Kcebfbkng3rUpGbP8raUH8tEBTnptcHA7C8vSRQr3tioyjLyX1EkwSl?rdid=OWy8v8TVS3dNKTY5#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
        "fecha" : "�️En #Tizayuca capacitamos a los Comités de Contraloría Social para fortalecer su labor en la vigilancia y seguimiento de las obras públicas, así como en el correcto uso de los recursos.",
    },

    
     {
        "imagen" : "assets/imgs/Comités de Contraloría Social.jpg",
        "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid069Cn8SMoaKW6d46yC7aPJEBu5nygdBtmZP14ki8bSrhBNHYQAeu3SZXFqEijUhXTl?rdid=KaK089kb9tcY0sNY#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Tu creatividad también puede ser reconocida. Participa en Transparencia en Corto 2026 ",    
       
    }, 
    
    {
        "imagen" : "assets/imgs/bienestar.jpg",
        "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid0ErX5oRA6yudW9rW5ZuRk6dSKkhFP2HZMS27Dc4WGnFLixvm57HYUyMs5qk2ptKEwl?rdid=L56Lg92Z7SozlHcT#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "La Contraloría acompañó a la Secretaría de Bienestar e Inclusión Social Hidalgo.",
    },     
  
    {
        "imagen" : "assets/imgs/cuarto.jpg",
         "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid02tGjyRcML7Gpyz9SZKxmruD6YpEiMN1br4iPPn9oVBZ5721DavuEHXUQ5bhbRd8HGl?rdid=UE94SG8hPtl1k9Bm#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "En el marco del 4.º Encuentro Nacional por la Armonización Legislativa y el Fortalecimiento del Sistema de Fiscalización en México.",
    },
   

     {
        "imagen" : "assets/imgs/fiscalizacion.jpg",
        "url" : "https://www.facebook.com/reel/1025266860337913",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "4.º Encuentro Nacional por la Armonización Legislativa y el Fortalecimiento del Sistema de Fiscalización en México.",
    },
    {
        "imagen" : "assets/imgs/emergente.jpg",
         "url" : "https://www.facebook.com/SecretariaContraloriaHgo/posts/pfbid02LfS1ifFmQcR6YuHSgg4p1eXoRBYf7yFDuVgSggRDHJS7ZRZxM85mLd8c7VRND7xPl?rdid=4QJhdL7HbjBMIYO2#",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "�La Contraloría participó en el foro “Tecnologías Emergentes para un Gobierno Inteligente”",
    },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]